/**
 * @generated SignedSource<<d9a962928beb19e28e676e64454d613f>>
 * @relayHash de6c8bfe85bc435492f9bac6b5384414
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bfbc418e9f2898c0155c3517140fcbe5c69196395ba60be243f33957c074b3b5

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserGuildMembershipsScreenQuery$variables = {
  id: string;
};
export type UserGuildMembershipsScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "User";
    readonly firstName: string;
    readonly lastName: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserGuildMembershipsEditorsSection_user" | "UserGuildMembershipsMembersSection_user" | "UserGuildMembershipsOrganizersSection_user" | "UserMetadata_user">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type UserGuildMembershipsScreenQuery = {
  response: UserGuildMembershipsScreenQuery$data;
  variables: UserGuildMembershipsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "membershipLevel": "ORGANIZER"
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blueskyIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildMembership",
                "kind": "LinkedField",
                "name": "myMembership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "membershipLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Literal",
                            "name": "dpr",
                            "value": 3
                          },
                          {
                            "kind": "Literal",
                            "name": "fit",
                            "value": "cover"
                          },
                          {
                            "kind": "Literal",
                            "name": "h",
                            "value": 100
                          },
                          {
                            "kind": "Literal",
                            "name": "w",
                            "value": 100
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "fit": "cover",
                          "h": 200,
                          "w": 500
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":200,\"w\":500})"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "h": 200,
                      "w": 500
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "defaultBackgroundUrl",
                "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":3,\"h\":200,\"w\":500})"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = [
  "condition"
],
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v11 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "membershipLevel": "MEMBER"
    }
  },
  (v10/*: any*/)
],
v12 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "membershipLevel": "EDITOR"
    }
  },
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserGuildMembershipsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserMetadata_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserGuildMembershipsOrganizersSection_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserGuildMembershipsMembersSection_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserGuildMembershipsEditorsSection_user"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserGuildMembershipsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "organizingGuilds",
                "args": (v7/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:6)"
              },
              {
                "alias": "organizingGuilds",
                "args": (v7/*: any*/),
                "filters": (v9/*: any*/),
                "handle": "connection",
                "key": "UserGuildMembershipsOrganizersSection_user_organizingGuilds",
                "kind": "LinkedHandle",
                "name": "guildMemberships"
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"MEMBER\"},first:3)"
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "filters": (v9/*: any*/),
                "handle": "connection",
                "key": "UserGuildMembershipsMembersSection_user_guildMemberships",
                "kind": "LinkedHandle",
                "name": "guildMemberships"
              },
              {
                "alias": "editingGuilds",
                "args": (v12/*: any*/),
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
              },
              {
                "alias": "editingGuilds",
                "args": (v12/*: any*/),
                "filters": (v9/*: any*/),
                "handle": "connection",
                "key": "UserGuildMembershipsEditorsSection_user_editingGuilds",
                "kind": "LinkedHandle",
                "name": "guildMemberships"
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bfbc418e9f2898c0155c3517140fcbe5c69196395ba60be243f33957c074b3b5",
    "metadata": {},
    "name": "UserGuildMembershipsScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e02ca9c5d743d49db21941bb409dc05";

export default node;
